import { useQuery } from '@apollo/client';
import { gql } from '@apollo/client/core';
export const GET_FEATURE_FLAG = gql`
  query GetFeatureFlag($name: String!, $label: String) {
    getFeatureFlag(name: $name, label: $label) {
      value
      name
    }
  }
`;
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/explicit-module-boundary-types
export const useFeatureFlag = (flag: string) => {
  const {
    data: featureData,
    loading,
    error: error
  } = useQuery(GET_FEATURE_FLAG, {
    // client: astBffApolloClient,
    variables: {
      name: flag,
      label: flag
    }
  });

  const data = {
    featureValue: featureData?.getFeatureFlag?.value
  };

  return { data, loading: loading, error: error };
};
